:host {
  display: block;
  font-family: var(--cms-base-font);
  padding-bottom: var(--cms-spacing-050);
  --cms-price-font-size: initial;
  --cms-price-line-height: initial;
  font-weight: var(--cms-heading-base-font-weight);
}

@include price-font-sizes();

.prefix {
  color: var(--cms-semanticColors-buy-strong-text);
  font-family: var(--cms-brandfont2);
  text-transform: lowercase;
}

.price {
  color: var(--cms-semanticColors-buy-strong-text);
  font-family: var(--cms-brandfont1);
  display: inline-block;
  font-size: var(--cms-price-font-size);
  line-height: var(--cms-price-line-height);

}

.unit {
  font-size: var(--cms-font-size-087);
  color: var(--cms-semanticColors-buy-strong-text);
  font-family: var(--cms-brandfont2);
}

.bracket {
  color: var(--cms-semanticColors-buy-medium-text);
  display: block;
  font-family: var(--cms-brandfont2);
  font-size: var(--cms-font-size-100);
  line-height: var(--cms-line-height-100);
}